/* JRC product page, mobile purchase area (2026-09-08)
   1. Mobile order: on phones (theme product breakpoint, <= 749px) the purchase
      group [warning callouts, quantity + Add to cart, dispatch bar] is moved
      directly after the variant picker, then the guide-style compatibility
      note ("Will this fit your stem?"), then the spec strip, so the DOM
      (reading / tab) order equals the visual order. On wider screens the
      group is restored to where Liquid rendered it and the spec strip goes
      back under the gallery; the guide note sits under the dispatch bar on
      every width (Josh 2026-09-08: above the button it read as a deterrent).
   2. <jrc-sticky-atc>: compact sticky bar (price + colour selector + Add to
      cart) that appears only after the main purchase row has scrolled above the
      viewport. It never posts to the cart itself: it submits the main product
      form, so the theme's product-form handler, variant validation and the
      "Complete your setup" add-on hook all run unchanged. Its colour panel is a
      mirror of the page's own variant picker: picking a colour checks the
      matching page radio and fires the theme's normal variant-change flow. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var mq = window.matchMedia(MOBILE);

  /* ------------------------------------------------------------ layout */

  var records = new WeakMap(); // node -> { parent, next } as rendered by Liquid

  function remember(node) {
    if (!node || records.has(node)) return;
    records.set(node, { parent: node.parentNode, next: node.nextSibling });
  }

  function restore(node) {
    var r = node && records.get(node);
    if (!r || !r.parent) return;
    if (r.next && r.next.parentNode === r.parent) r.parent.insertBefore(node, r.next);
    else r.parent.appendChild(node);
  }

  function after(ref, node) {
    if (!ref || !node || !ref.parentNode) return;
    ref.parentNode.insertBefore(node, ref.nextSibling);
  }

  function childOf(container, el) {
    while (el && el.parentNode !== container) el = el.parentNode;
    return el;
  }

  function applyLayout(info) {
    var section = info.closest('.shopify-section') || document;
    var picker = childOf(info, info.querySelector('variant-selects, variant-radios'));
    var price = childOf(info, info.querySelector('.price-rating-container, [id^="price-"]'));
    var anchor = picker || price;
    var allCallouts = Array.prototype.slice.call(info.querySelectorAll(':scope > .product__callout'));
    var guides = allCallouts.filter(function (c) { return c.classList.contains('product__callout--guide'); });
    var callouts = allCallouts.filter(function (c) { return guides.indexOf(c) === -1; });
    var purchase = info.querySelector(':scope > .product-form__custom-input');
    var dispatch = info.querySelector(':scope > .jrc-sdd');
    var strip = section.querySelector('.jrc-specs');
    var media = section.querySelector('.product__media-wrapper');
    var share = section.querySelector('share-button');
    var accordions = media && media.querySelector('.product__accordion-wrapper');

    var moved = callouts.concat([purchase, dispatch]).filter(Boolean);
    moved.forEach(remember);
    guides.forEach(remember);
    if (strip) remember(strip);
    if (share) remember(share);

    if (mq.matches) {
      if (anchor) {
        var ref = anchor;
        moved.forEach(function (node) { after(ref, node); ref = node; });
      }
      var tail = dispatch || purchase || anchor;
      guides.forEach(function (g) { after(tail, g); tail = g; });
      if (strip) after(tail, strip);
      if (share) restore(share); // under the info-column (mobile) accordions
    } else {
      if (strip) {
        var gallery = media && (media.querySelector('media-gallery') || media.firstElementChild);
        if (gallery) after(gallery, strip); else restore(strip);
      }
      if (share) { if (accordions) after(accordions, share); else restore(share); }
      moved.slice().reverse().forEach(restore);
      // guide note under the dispatch bar on desktop too
      var dtail = dispatch || purchase;
      guides.forEach(function (g) { if (dtail) { after(dtail, g); dtail = g; } else restore(g); });
    }
  }

  function layoutAll() {
    Array.prototype.forEach.call(document.querySelectorAll('product-info:not([data-original-section])'), applyLayout);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', layoutAll);
  else layoutAll();
  (mq.addEventListener ? mq.addEventListener('change', layoutAll) : mq.addListener(layoutAll));
  document.addEventListener('shopify:section:load', layoutAll);

  /* ------------------------------------------------------------ sticky bar */

  var OVERLAYS = [
    'cart-drawer.active',
    'details-modal details[open]',
    '#Details-menu-drawer-container[open]',
    'menu-drawer details[open]',
    'product-modal[open]',
    'quick-add-modal[open]',
    'dialog[open]',
    '.pswp--open',
    '#Modalnewsletter--alt.show'
  ].join(',');
  var TIMESACT_BIS = '.timesact_bis_dialog, .timesact_bis_popup_overlay';

  var strings = window.variantStrings || {};

  // Money helpers: the page already renders every price in the shopper's
  // currency, so totals are built from the displayed strings and written back
  // in the same format (no separate currency logic, no bundle maths).
  function parseMoney(text) {
    var m = String(text || '').match(/\d[\d.,\s]*/);
    if (!m) return null;
    var raw = m[0].replace(/\s/g, '');
    var dec = '';
    var last = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(','));
    if (last > -1 && raw.length - last - 1 === 2) dec = raw.charAt(last);
    var num = dec ? raw.slice(0, last).replace(/[.,]/g, '') + '.' + raw.slice(last + 1) : raw.replace(/[.,]/g, '');
    var val = parseFloat(num);
    return isNaN(val) ? null : { value: val, dec: dec, raw: m[0], index: m.index };
  }
  function formatLike(template, value) {
    var t = parseMoney(template);
    if (!t) return template;
    var dec = t.dec || '.';
    var thou = dec === ',' ? '.' : ',';
    var fixed = value.toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var out = t.dec ? parts[0] + dec + parts[1] : parts[0] + dec + parts[1];
    return template.slice(0, t.index) + out + template.slice(t.index + t.raw.length);
  }

  // True when an element is actually painted somewhere in the viewport
  // (works for position: fixed, where offsetParent is always null).
  function shown(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }
  var CHOOSE = 'Choose options';

  if (!customElements.get('jrc-sticky-atc')) {
    customElements.define('jrc-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.sectionId = this.dataset.sectionId;
        this.formId = this.dataset.formId;

        // Live in <body> so no transformed ancestor can break position: fixed.
        if (this.parentNode !== document.body) {
          Array.prototype.forEach.call(document.body.querySelectorAll('jrc-sticky-atc[data-section-id="' + this.sectionId + '"]'), function (old) {
            if (old !== self) old.remove();
          });
          document.body.appendChild(this);
          return; // connectedCallback runs again after the move
        }

        this.form = document.getElementById(this.formId);
        this.mainBtn = this.form && this.form.querySelector('[name="add"]');
        if (!this.form || !this.mainBtn) return;
        this.mainText = this.mainBtn.querySelector('span');
        this.row = this.form.closest('.product-form__custom-input') || this.form.closest('product-form') || this.form;
        this.priceEl = document.getElementById('price-' + this.sectionId);
        this.btn = this.querySelector('.jrc-satc__btn');
        this.label = this.querySelector('.jrc-satc__label');
        this.priceOut = this.querySelector('.jrc-satc__price');
        this.errorOut = this.querySelector('.jrc-satc__error');

        // colour panel (only rendered when the product has a real colour choice)
        this.optionName = this.dataset.optionName || '';
        this.optionIndex = this.dataset.optionPosition ? parseInt(this.dataset.optionPosition, 10) - 1 : -1;
        this.trigger = this.querySelector('.jrc-satc__colour');
        this.panel = this.querySelector('.jrc-satc__panel');
        this.backdrop = this.querySelector('.jrc-satc__backdrop');
        this.closeBtn = this.panel && this.panel.querySelector('.jrc-satc__panel-close');
        this.variantSelects = document.querySelector('product-info[data-section="' + this.sectionId + '"] variant-selects') || document.getElementById('variant-selects-' + this.sectionId);
        this.panelOpen = false;

        this.pastRow = false;
        this.keyboard = false;
        this.mode = 'add';
        this.busy = false;

        this.bound = {
          sync: this.schedule.bind(this, 'sync'),
          update: this.schedule.bind(this, 'update'),
          click: this.onClick.bind(this),
          focusin: this.onFocus.bind(this, true),
          focusout: this.onFocus.bind(this, false),
          cartError: this.onCartError.bind(this)
        };

        this.btn.addEventListener('click', this.bound.click);
        if (this.trigger && this.panel && this.variantSelects) {
          this.bound.toggle = this.togglePanel.bind(this);
          this.bound.close = function () { self.closePanel(true); };
          this.bound.keydown = function (e) { if (e.key === 'Escape' && self.panelOpen) { e.preventDefault(); self.closePanel(true); } };
          this.bound.pick = this.onPanelPick.bind(this);
          this.trigger.addEventListener('click', this.bound.toggle);
          this.closeBtn.addEventListener('click', this.bound.close);
          this.backdrop.addEventListener('click', this.bound.close);
          this.addEventListener('keydown', this.bound.keydown);
          this.panel.addEventListener('change', this.bound.pick);
          // page picker -> panel (variant change is also caught by the button/price observers)
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
            this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.bound.sync);
          }
          this.variantSelects.addEventListener('change', this.bound.sync);
        } else if (this.trigger) {
          this.trigger.hidden = true;
        }
        // add-on radios toggle on click (the box deselects on a second click, which
        // fires no change event) -> re-sync after their handler has run
        this.bound.cys = function () { setTimeout(self.bound.sync, 0); };
        document.addEventListener('click', this.bound.cysClick = function (e) { if (e.target && e.target.closest && e.target.closest('#jrc-cys .jrc-cys__row')) self.bound.cys(); });
        document.addEventListener('change', this.bound.cysChange = function (e) { if (e.target && e.target.closest && e.target.closest('#jrc-cys')) self.bound.cys(); });

        // Mirror the main button + price. global.js rewrites these on variant change.
        this.mo = new MutationObserver(this.bound.sync);
        this.mo.observe(this.mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'style'], childList: true, characterData: true, subtree: true });
        if (this.priceEl) this.mo.observe(this.priceEl, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
        // the purchase row itself: apps insert/remove/show buttons here (Timesact notify)
        this.mo.observe(this.row, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'disabled', 'hidden'] });

        // Overlays: body.overflow-hidden, [open] on details/dialog/modals, drawer .active
        this.bodyMo = new MutationObserver(this.bound.update);
        this.bodyMo.observe(document.body, { attributes: true, attributeFilter: ['class', 'open', 'style', 'hidden'], subtree: true, childList: true });

        // Show only once the purchase row has scrolled ABOVE the viewport.
        this.io = new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          var top = e.rootBounds ? e.rootBounds.top : 0;
          self.pastRow = !e.isIntersecting && e.boundingClientRect.bottom <= top;
          self.schedule('update');
        }, { threshold: 0 });
        this.io.observe(this.row);

        document.addEventListener('focusin', this.bound.focusin);
        document.addEventListener('focusout', this.bound.focusout);
        window.addEventListener('resize', this.bound.update, { passive: true });
        if (window.visualViewport) window.visualViewport.addEventListener('resize', this.bound.update);
        (mq.addEventListener ? mq.addEventListener('change', this.bound.update) : mq.addListener(this.bound.update));
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
          this.unsubError = subscribe(PUB_SUB_EVENTS.cartError, this.bound.cartError);
        }

        this.sync();
      }

      disconnectedCallback() {
        if (this.parentNode === null && this.sectionId && this.mo) {
          this.mo.disconnect(); this.bodyMo.disconnect(); this.io.disconnect();
          document.removeEventListener('focusin', this.bound.focusin);
          document.removeEventListener('focusout', this.bound.focusout);
          document.removeEventListener('click', this.bound.cysClick);
          document.removeEventListener('change', this.bound.cysChange);
          if (this.unsubVariant) this.unsubVariant();
          if (this.variantSelects) this.variantSelects.removeEventListener('change', this.bound.sync);
          this.closePanel(false);
          window.removeEventListener('resize', this.bound.update);
          if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.bound.update);
          (mq.removeEventListener ? mq.removeEventListener('change', this.bound.update) : mq.removeListener(this.bound.update));
          if (this.unsubError) this.unsubError();
          this.setVisible(false);
          this.mo = null;
        }
      }

      schedule(what) {
        var self = this;
        if (what === 'sync') this.needSync = true;
        if (this.raf) return;
        this.raf = requestAnimationFrame(function () {
          self.raf = null;
          var doSync = self.needSync;
          self.needSync = false;
          if (doSync) self.sync(); else self.update();
        });
      }

      currentPrice() {
        if (!this.priceEl || this.priceEl.classList.contains('hidden')) return '';
        var sale = this.priceEl.querySelector('.price--on-sale .price__sale .price-item--sale');
        var reg = this.priceEl.querySelector('.price__regular span.price-item--regular');
        var el = sale || reg;
        var text = el ? el.textContent.trim() : '';
        // Selected "Complete your setup" add-on: show product + add-on (its discounted
        // price where the page shows one, otherwise its listed price).
        var chosen = document.querySelector('#jrc-cys .jrc-cys__radio:checked');
        var row = chosen && chosen.closest('.jrc-cys__row');
        var addEl = row && (row.querySelector('.jrc-cys__now') || row.querySelector('.jrc-cys__was'));
        if (text && addEl) {
          var base = parseMoney(text), add = parseMoney(addEl.textContent);
          if (base && add) return formatLike(text, base.value + add.value);
        }
        return text;
      }

      sync() {
        var btn = this.mainBtn;
        var text = this.mainText ? this.mainText.textContent.trim() : btn.textContent.trim();
        var disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
        var loading = btn.classList.contains('loading');
        // The main button can be replaced by an app: Timesact hides it on sold-out
        // variants and inserts its back-in-stock button a moment later. Mirror that
        // button when it is there; until then keep mirroring the main button's own
        // (Sold out, disabled) state. Never hide the bar for this.
        this.notifyBtn = null;
        if (btn.offsetParent === null && this.row.offsetParent !== null) {
          var bis = this.row.querySelector('.timesact-button-bis, [class*="timesact-button-bis"]');
          // displayed (not necessarily on screen: the row is scrolled away when the bar shows)
          if (bis && getComputedStyle(bis).display !== 'none' && bis.getBoundingClientRect().width > 0) this.notifyBtn = bis;
        }

        // "Unavailable" = the chosen option combination has no variant: send the
        // customer back to the options rather than guessing a different variant.
        this.mode = text === (strings.unavailable || 'Unavailable') ? 'choose' : 'add';
        if (this.notifyBtn) this.mode = 'notify';

        if (this.mode === 'choose') {
          this.label.textContent = CHOOSE;
          this.btn.disabled = false;
        } else if (this.mode === 'notify') {
          this.label.textContent = this.notifyBtn.textContent.trim() || 'Notify when available';
          this.btn.disabled = false;
          loading = false;
        } else {
          this.label.textContent = text || (strings.addToCart || 'Add to cart');
          this.btn.disabled = disabled || loading;
        }
        this.btn.classList.toggle('loading', loading);
        this.btn.setAttribute('aria-busy', loading ? 'true' : 'false');
        this.busy = loading;
        this.priceOut.textContent = this.mode === 'choose' ? '' : this.currentPrice();
        this.syncPicker();
        this.update();
      }

      /* ---------- colour panel: a view of the page's own variant picker ---------- */

      pageRadios() {
        return this.variantSelects ? Array.prototype.slice.call(this.variantSelects.querySelectorAll('input[type="radio"][name="' + this.optionName + '"]')) : [];
      }

      // current value of every option, in option order, straight from the page picker
      selectedOptions() {
        return Array.prototype.map.call(this.variantSelects.querySelectorAll('select, fieldset'), function (el) {
          if (el.tagName === 'SELECT') return el.value;
          var r = el.querySelector('input:checked');
          return r ? r.value : undefined;
        });
      }

      // value -> is there an available variant with this colour AND the other options as chosen now
      availability() {
        var map = {};
        var data;
        try { data = JSON.parse(this.variantSelects.querySelector('[type="application/json"]').textContent); } catch (e) { return map; }
        var chosen = this.selectedOptions();
        var idx = this.optionIndex;
        this.panel.querySelectorAll('input[type="radio"]').forEach(function (r) {
          var v = r.value;
          map[v] = data.some(function (variant) {
            if (!variant.available) return false;
            return variant.options.every(function (o, i) { return i === idx ? o === v : (chosen[i] === undefined || o === chosen[i]); });
          });
        });
        return map;
      }

      syncPicker() {
        if (!this.trigger || !this.panel || !this.variantSelects) return;
        var radios = this.pageRadios();
        var checked = radios.filter(function (r) { return r.checked; })[0];
        var value = checked ? checked.value : '';
        this.querySelector('.jrc-satc__colour-name').textContent = value || 'Choose';
        var sw = this.querySelector('.jrc-satc__colour-swatch');
        var pageLabel = checked && this.variantSelects.querySelector('label[for="' + checked.id + '"]');
        sw.setAttribute('style', pageLabel ? (pageLabel.getAttribute('style') || '') : '');
        var avail = this.availability();
        var panel = this.panel;
        panel.querySelectorAll('input[type="radio"]').forEach(function (r) {
          var ok = avail[r.value] !== false;
          r.checked = r.value === value;
          r.classList.toggle('disabled', !ok);
          var l = panel.querySelector('label[for="' + r.id + '"]');
          if (l) l.classList.toggle('variant--sold-out', !ok);
          var cell = r.closest('.jrc-satc__cell');
          var stock = cell && cell.querySelector('.jrc-satc__cell-stock');
          if (stock) stock.hidden = ok;
        });
      }

      onPanelPick(e) {
        var r = e.target;
        if (!r || r.type !== 'radio') return;
        if (this.busy) { this.syncPicker(); return; } // no colour changes mid add-to-cart
        var value = r.value;
        var target = this.pageRadios().filter(function (p) { return p.value === value; })[0];
        if (target && !target.checked) {
          target.checked = true;
          // the page picker's own flow: URL, price, media, availability, button state
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // The panel stays open (Josh 2026-09-08): the shopper can compare colours and
        // add to cart straight from the bar underneath; close is via X / backdrop / Escape.
      }

      togglePanel() {
        if (this.panelOpen) this.closePanel(true); else this.openPanel();
      }

      openPanel() {
        if (!this.panel || this.panelOpen || this.busy || !mq.matches) return;
        this.syncPicker();
        this.panel.hidden = false;
        this.backdrop.hidden = false;
        this.panelOpen = true;
        this.classList.add('is-panel-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('jrc-satc-panel-open');
        var focusTarget = this.panel.querySelector('input[type="radio"]:checked') || this.closeBtn;
        if (typeof trapFocus === 'function') trapFocus(this, focusTarget);
        else if (focusTarget) focusTarget.focus();
      }

      closePanel(restoreFocus) {
        if (!this.panel || !this.panelOpen) return;
        this.panel.hidden = true;
        this.backdrop.hidden = true;
        this.panelOpen = false;
        this.classList.remove('is-panel-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('jrc-satc-panel-open');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(restoreFocus ? this.trigger : null);
        else if (restoreFocus) this.trigger.focus();
      }

      obstructed() {
        if (document.body.classList.contains('overflow-hidden')) return true;
        if (document.querySelector(OVERLAYS)) return true;
        var ta = document.querySelectorAll(TIMESACT_BIS);
        for (var j = 0; j < ta.length; j++) if (shown(ta[j])) return true;
        // Cookie-consent bars dock to the bottom edge (Shopify's own, Avada Cookies)
        var bars = document.querySelectorAll('#shopify-pc__banner, .Avada-CookiesMobile, .Avada-CookiesBar, .Avada-CookiesBar_Container');
        for (var i = 0; i < bars.length; i++) {
          if (shown(bars[i]) && bars[i].getBoundingClientRect().bottom > window.innerHeight - 200) return true;
        }
        if (window.visualViewport && window.visualViewport.height < window.innerHeight - 150) return true;
        return false;
      }

      onFocus(entering, e) {
        var t = e.target;
        var typing = entering && t && t.matches && t.matches('input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]), textarea, select') && !this.contains(t);
        this.keyboard = !!typing;
        this.schedule('update');
      }

      update() {
        var show = mq.matches && this.pastRow && !this.keyboard && !this.obstructed();
        if (!show && this.panelOpen) this.closePanel(false);
        this.setVisible(show);
      }

      setVisible(show) {
        if (this.visible === show) return;
        this.visible = show;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        var root = document.documentElement;
        if (show) {
          var bar = this.querySelector('.jrc-satc__bar') || this;
          root.style.setProperty('--jrc-satc-h', bar.offsetHeight + 'px');
          root.classList.add('jrc-satc-open');
        } else {
          root.classList.remove('jrc-satc-open');
          if (this.errorOut) this.errorOut.hidden = true;
        }
      }

      onClick() {
        if (this.mode === 'choose') {
          if (this.trigger && this.panel && !this.trigger.hidden) { this.openPanel(); return; }
          var picker = document.querySelector('product-info[data-section="' + this.sectionId + '"] variant-selects, product-info[data-section="' + this.sectionId + '"] variant-radios');
          if (picker) {
            picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var first = picker.querySelector('input:not([disabled]), select');
            if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
          }
          return;
        }
        if (this.mode === 'notify' && this.notifyBtn) {
          this.notifyBtn.click(); // existing back-in-stock flow (Timesact dialog)
          return;
        }
        if (this.busy || this.btn.disabled) return;
        if (this.errorOut) this.errorOut.hidden = true;
        // Same validated path as the main button: product-form.js handles the submit event.
        if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(this.mainBtn);
        else this.mainBtn.click();
      }

      onCartError(ev) {
        if (!this.visible || !this.errorOut) return;
        var msg = (ev && (ev.message || ev.errors)) || 'Could not add to cart. Please try again.';
        this.errorOut.textContent = typeof msg === 'string' ? msg : 'Could not add to cart. Please try again.';
        this.errorOut.hidden = false;
      }
    });
  }

  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id) return;
    Array.prototype.forEach.call(document.body.querySelectorAll('jrc-sticky-atc[data-section-id="' + id + '"]'), function (el) { el.remove(); });
  });
})();
